"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extraFieldsValidators = exports.validators = exports.beneficiaryCustomerIdentification = exports.originatorCustomerIdentification = exports.beneficiaryAccountNumber = exports.originatorAccountNumber = exports.beneficiaryName = exports.beneficiaryGeographicAddress = exports.originatorGeographicAddress = exports.beneficiaryDateAndPlaceOfBirth = exports.originatorDateAndPlaceOfBirth = exports.beneficiaryNationalIdentification = exports.originatorNationalIdentification = exports.originatorName = void 0;
const yup = __importStar(require("yup"));
const ivms_1 = require("../../../schemas/ivms");
const ownershipProof_1 = require("../../../schemas/ownershipProof");
exports.originatorName = yup.object({
    originator: yup
        .object({ originatorPersons: ivms_1.naturalOrLegalPersonName.required() })
        .required(),
});
exports.originatorNationalIdentification = yup.object({
    originator: yup
        .object({
        originatorPersons: ivms_1.naturalOrLegalPersonNationalIdentification.required(),
    })
        .required(),
});
exports.beneficiaryNationalIdentification = yup.object({
    beneficiary: yup
        .object({
        beneficiaryPersons: ivms_1.naturalOrLegalPersonNationalIdentification.required(),
    })
        .required(),
});
exports.originatorDateAndPlaceOfBirth = yup.object({
    originator: yup
        .object({
        originatorPersons: ivms_1.naturalOrLegalPersonDateAndPlaceOfBirth.required(),
    })
        .required(),
});
exports.beneficiaryDateAndPlaceOfBirth = yup.object({
    beneficiary: yup
        .object({
        beneficiaryPersons: ivms_1.naturalOrLegalPersonDateAndPlaceOfBirth.required(),
    })
        .required(),
});
exports.originatorGeographicAddress = yup.object({
    originator: yup
        .object({
        originatorPersons: ivms_1.naturalOrLegalPersonGeographicAddress.required(),
    })
        .required(),
});
exports.beneficiaryGeographicAddress = yup.object({
    beneficiary: yup
        .object({
        beneficiaryPersons: ivms_1.naturalOrLegalPersonGeographicAddress.required(),
    })
        .required(),
});
exports.beneficiaryName = yup.object({
    beneficiary: yup
        .object({ beneficiaryPersons: ivms_1.naturalOrLegalPersonName.required() })
        .required(),
});
exports.originatorAccountNumber = yup.object({
    originator: yup
        .object({ accountNumber: ivms_1.accountNumbers.required() })
        .required(),
});
exports.beneficiaryAccountNumber = yup.object({
    beneficiary: yup
        .object({ accountNumber: ivms_1.accountNumbers.required() })
        .required(),
});
exports.originatorCustomerIdentification = yup.object({
    originator: yup
        .object({
        originatorPersons: ivms_1.naturalOrLegalPersonCustomerIdentification.required(),
    })
        .required(),
});
exports.beneficiaryCustomerIdentification = yup.object({
    beneficiary: yup
        .object({
        beneficiaryPersons: ivms_1.naturalOrLegalPersonCustomerIdentification.required(),
    })
        .required(),
});
exports.validators = {
    originatorName: exports.originatorName,
    originatorAccountNumber: exports.originatorAccountNumber,
    originatorNationalIdentification: exports.originatorNationalIdentification,
    originatorDateAndPlaceOfBirth: exports.originatorDateAndPlaceOfBirth,
    originatorGeographicAddress: exports.originatorGeographicAddress,
    originatorCustomerIdentification: exports.originatorCustomerIdentification,
    beneficiaryName: exports.beneficiaryName,
    beneficiaryAccountNumber: exports.beneficiaryAccountNumber,
    beneficiaryDateAndPlaceOfBirth: exports.beneficiaryDateAndPlaceOfBirth,
    beneficiaryNationalIdentification: exports.beneficiaryNationalIdentification,
    beneficiaryGeographicAddress: exports.beneficiaryGeographicAddress,
    beneficiaryCustomerIdentification: exports.beneficiaryCustomerIdentification,
};
exports.extraFieldsValidators = {
    originatorOwnershipProof: ownershipProof_1.ownershipProof,
    beneficiaryOwnershipProof: ownershipProof_1.ownershipProof,
};
